import { httpApi } from '@app/api/http.api';
import {
  Media,
  MediaPaginatedResponse,
  MediaFilters,
} from '@app/types/api.types';

// Normalize media URL by replacing backslashes with forward slashes
const normalizeMediaUrl = (url: string): string => {
  if (!url) return url;
  return url.replace(/\\/g, '/');
};

// Normalize media object URLs
const normalizeMedia = (media: Media): Media => {
  return {
    ...media,
    url: normalizeMediaUrl(media.url),
    path: normalizeMediaUrl(media.path),
  };
};

// Normalize media array
const normalizeMediaArray = (mediaArray: Media[]): Media[] => {
  return mediaArray.map(normalizeMedia);
};

export const uploadFile = (file: File, alt?: string): Promise<Media> => {
  const formData = new FormData();
  formData.append('file', file);
  if (alt) {
    formData.append('alt', alt);
  }

  return httpApi
    .post<Media>('/media/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then(({ data }) => normalizeMedia(data));
};

export const getMedia = (filters?: MediaFilters): Promise<MediaPaginatedResponse> =>
  httpApi
    .get<MediaPaginatedResponse>('/media', { params: filters })
    .then(({ data }) => ({
      ...data,
      data: normalizeMediaArray(data.data),
    }));

export const getMediaById = (id: string): Promise<Media> =>
  httpApi.get<Media>(`/media/${id}`).then(({ data }) => normalizeMedia(data));

export const deleteMedia = (id: string): Promise<void> =>
  httpApi.delete<void>(`/media/${id}`).then(() => undefined);

